import { useState } from "react";
import { BaseNode } from "./baseNode";

export const OutputNode = ({ id, data }) => {
  const [currName, setCurrName] = useState(
    data?.outputName || id.replace("customOutput-", "output_"),
  );

  const [outputType, setOutputType] = useState(data?.outputType || "Text");

  return (
    <BaseNode id={id} title="Output" leftHandles={[{ id: `${id}-value`, top: "50%", label: "Input" }]}>
      <div className="space-y-3">
        <label className="flex flex-col gap-1 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">
          Name
          <input
            type="text"
            className="nodrag px-3 py-2 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary/50 transition-all font-medium text-gray-700 dark:text-gray-200"
            value={currName}
            onChange={(e) => setCurrName(e.target.value)}
          />
        </label>

        <label className="flex flex-col gap-1 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">
          Type
          <select
            className="nodrag px-3 py-2 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary/50 transition-all font-medium text-gray-700 dark:text-gray-200"
            value={outputType}
            onChange={(e) => setOutputType(e.target.value)}
          >
            <option value="Text">Text</option>
            <option value="File">Image</option>
          </select>
        </label>
      </div>
    </BaseNode>
  );
};
